import './AssessmentFlow.css';

const SEVERITY_LABELS = [
    { value: 0, label: 'Never' },
    { value: 1, label: 'Occasionally' },
    { value: 2, label: 'Frequently' },
    { value: 3, label: 'Constantly' },
];

export default function SeverityInput({ value, onChange }) {
    return (
        <div className="severity-input">
            {SEVERITY_LABELS.map(option => (
                <button
                    key={option.value}
                    type="button"
                    className={`severity-btn ${value === option.value ? 'selected' : ''}`}
                    onClick={() => onChange(option.value)}
                >
                    <span className="severity-value">{option.value}</span>
                    <span className="severity-label">{option.label}</span>
                </button>
            ))}
        </div>
    );
}
